import React from 'react';
import { Menu, MenuItem } from '@blueprintjs/core';
import './UserMenuPopover.css';

const UserMenuPopover = ({ handleLogout, location, history, match }) => {
  return (
    <Menu>
      <MenuItem
        text="Today"
        iconName="pt-icon-calendar"
        onClick={() => history.push('/dailySummary', { from: location.pathname })}
      />
      <MenuItem
        className="user-completed-games-link"
        text="Games Report"
        iconName="pt-icon-th"
        onClick={() => history.push('/umpireCompletedGames')}
      />
      <MenuItem
        className="user-profile-link"
        text="Profile"
        iconName="pt-icon-person"
        onClick={() => history.push('/profile')}
      />
      <MenuItem className="logout" text="Log Out" iconName="pt-icon-log-out" onClick={handleLogout} />
    </Menu>
  );
};

export default UserMenuPopover;



// WEBPACK FOOTER //
// ./src/components/UserMenuPopover.js